import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const http = axios.create({ baseURL: API, timeout: 20000 });

export const createBill = (title) => http.post("/bills", { title }).then((r) => r.data);
export const getBill = (id) => http.get(`/bills/${id}`).then((r) => r.data);
export const patchBill = (id, patch) => http.patch(`/bills/${id}`, patch).then((r) => r.data);
export const getSummary = (id) => http.get(`/bills/${id}/summary`).then((r) => r.data);
export const uploadReceipt = (id, file, onProgress) => {
  const form = new FormData();
  form.append("file", file);
  return http
    .post(`/bills/${id}/receipt`, form, {
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress: onProgress,
      timeout: 90000,
    })
    .then((r) => r.data);
};
export const createShare = (id, expiry_days = 7) =>
  http.post(`/bills/${id}/share`, { expiry_days }).then((r) => r.data);

export const getShare = (token) => http.get(`/share/${token}`).then((r) => r.data);
export const sharePay = (token, participant_id, paid) =>
  http.post(`/share/${token}/pay`, { participant_id, paid }).then((r) => r.data);
export const shareClaim = (token, participant_id, item_id, claim) =>
  http.post(`/share/${token}/claim`, { participant_id, item_id, claim }).then((r) => r.data);

export const fileUrl = (path) => `${API}/files/${path}`;
